class SectionWebshop {

	constructor() {
		jQuery('body').on('click', 'a.add-to-cart', this.addToCart.bind(this));
		jQuery('body').on('click', 'button.remove-from-cart', this.removeFromCart.bind(this));
		jQuery('section.section-type-winkelwagen').on('change', 'input.cart-product-amount', this.updateAmount.bind(this));
		if (jQuery('#winkelwagen-items').length > 0) {
			this.addCartToForm();
		}
	}

	addToCart(event) {
		event.preventDefault();
		let $target = $(event.currentTarget);
		let $counter = jQuery('a.winkelwagen-indicator small.counter');
		let $warning = jQuery('a.winkelwagen-indicator .staal-warning.staal-success');
		let $error = jQuery('a.winkelwagen-indicator .staal-warning.staal-error');

		$.ajax({
			url: $target.attr('href'),
			data: {
				treeId: $target.data('treeId')
			},
			success: (response) => {
				let data = response;
				$counter.text(data.amount);
				$counter.next().text($counter.next().data('textok'));
				$warning.removeClass('d-none');
				setTimeout(function () {
					$warning.addClass('d-none');
				}, 2000);
			},
			error: (response) => {
				let data = response.responseJSON;
				$counter.next().text($counter.next().data('textnotok'));
				$error.text(data.message);
				$error.removeClass('d-none');
				setTimeout(function () {
					$error.addClass('d-none');
				}, 2000);
			}
		});
	}

	updateAmount(event) {
		let target = event.currentTarget;
		$.ajax({
			url: jQuery(target).data('href'),
			type: "GET",
			data: {amount: jQuery(target).val()},
			success: this.onSuccess.bind(this),
			error: this.onError.bind(this)
		});
	};

	removeFromCart(event) {
		event.preventDefault();
		let $target = $(event.currentTarget);

		$.ajax({
			url: $target.data('href'),
			type: "GET",
			success: this.onSuccess.bind(this),
			error: this.onError.bind(this),
		});
	}

	onSuccess(response) {
		let params = new URLSearchParams(window.location.search);
		params = Object.fromEntries(params);
		delete params['stalen-error'];
		let queryString = new URLSearchParams(params).toString();
		window.location.href = location.pathname + '?' + queryString
	}

	onError(response) {
		let params = new URLSearchParams(window.location.search);
		params = Object.fromEntries(params);
		params['stalen-error'] = response.responseJSON.message;
		let queryString = new URLSearchParams(params).toString();
		window.location.href = location.pathname + '?' + queryString
	}

	addCartToForm() {
		let html = '';
		jQuery('#winkelwagen-items div.cart-container').each(function (it, el) {
			html += jQuery(el).find('input.cart-product-amount').val() + 'x ' + jQuery.trim(jQuery(el).find('div.cart-title > a').text()) + "\n";
		});
		jQuery('form input[name="productenstalen-6"]').val(html);
	}
}

export default new SectionWebshop();